// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bootstrap-alert {
	z-index: 2000;
	position: fixed;
}

.top-left {
	left: 1rem;
	top: 1rem;
}

.top-center {
	margin: auto;
	left: 0;
	right: 0;
	top: 1rem;
}

.top-right {
	right: 1rem;
	top: 4rem;
}

.bottom-left {
	left: 1rem;
	bottom: 1rem;
}

.bottom-center {
	margin: auto;
	left: 0;
	right: 0;
	bottom: 1rem;
}

.bottom-right {
	right: 1rem;
	bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/widgets/ng-bootstrap-alert/bootstrap-alert.component.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,OAAO;CACP,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,WAAW;CACX,SAAS;AACV;;AAEA;CACC,UAAU;CACV,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,OAAO;CACP,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb","sourcesContent":[".bootstrap-alert {\n\tz-index: 2000;\n\tposition: fixed;\n}\n\n.top-left {\n\tleft: 1rem;\n\ttop: 1rem;\n}\n\n.top-center {\n\tmargin: auto;\n\tleft: 0;\n\tright: 0;\n\ttop: 1rem;\n}\n\n.top-right {\n\tright: 1rem;\n\ttop: 4rem;\n}\n\n.bottom-left {\n\tleft: 1rem;\n\tbottom: 1rem;\n}\n\n.bottom-center {\n\tmargin: auto;\n\tleft: 0;\n\tright: 0;\n\tbottom: 1rem;\n}\n\n.bottom-right {\n\tright: 1rem;\n\tbottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
